import { render, staticRenderFns } from "./handoffSuccess.vue?vue&type=template&id=6fab5172"
import script from "./handoffSuccess.vue?vue&type=script&lang=js"
export * from "./handoffSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports